import React, { Component } from 'react';
import { Checkbox } from '@rmwc/checkbox';
import { Radio } from '@rmwc/radio';
import { Select } from '@rmwc/select';
import Scrollbar from 'react-scrollbars-custom';
import { TextField } from '@rmwc/textfield';
import EditPriceItem from '../../EditPriceItem/EditPriceItem';
import OrderNow from '../Common/OrderNow.js';
import { connect } from "react-redux";
import * as actionCreator from "../../../action/index.js";
import * as cuComponent from '../../../redux/reducers/building_component/componentReducer.js';
import * as cuBuilding from '../../../redux/reducers/building_pricing/pricingReducer.js';
import * as validate from '../../Modals/validations';
import AnimButton from '../../Button/AnimButton.js';
class Tax extends Component {

  showTaxCal = (value) => {
    if (this.props.const_var.crmSetting.is_Edit != true && this.props.params.tax_exempt == true && this.props.const_var.LeadCustomerData && this.props.const_var.LeadCustomerData.address != undefined && this.props.const_var.LeadCustomerData.address.length > 0) {
      let selZipCode = this.props.const_var.LeadCustomerData.address.filter(obj => obj.is_billing == 1)
      selZipCode = selZipCode[0]
      this.props.callTaxApiAndCalculatePrice(selZipCode.zipcode)
      this.props.commonsActionforAttribute(value, "Tax", selZipCode.zipcode);
    }
    else if (this.props.const_var.crmSetting.is_Edit == true && this.props.const_var.duplicateTaxZipCode != '' && this.props.const_var.duplicateTaxZipCode != undefined && this.props.params.tax_exempt == true) {
      this.props.callTaxApiAndCalculatePrice(this.props.const_var.duplicateTaxZipCode)
      this.props.commonsActionforAttribute(value, "Tax", this.props.const_var.duplicateTaxZipCode);
    }
    else {
      this.props.commonsActionforAttribute(value, "Tax");
    }
  }

  render() {
    if (this.props.const_var.crmSetting.is_module_name == "inventory") {
      return null;
    } else {
      var defaultTaxVal = "";
      if (Object.keys(this.props.const_var.LeadCustomerData).length > 0 && this.props.const_var.LeadCustomerData.admin_id != undefined && this.props.const_var.crmSetting.is_Edit != true && this.props.const_var.LeadCustomerData.showZip != undefined) {
        if (this.props.const_var.LeadCustomerData.showZip != '' && this.props.params.tax_zipcode == '') {
          this.props.params.tax_zipcode = this.props.const_var.LeadCustomerData.showZip;
          cuBuilding.cP();
          if (this.props.const_var.LeadCustomerData.taxPersentage != undefined) {
            this.props.const_var.tax.percentage = this.props.const_var.LeadCustomerData.taxPersentage;
          }
        } else {
          this.props.params.tax_zipcode = this.props.params.tax_zipcode;
        }

      }
      let chkArr = false;
      if ((this.props.const_var.BuildingPriceArrar['insulation_calculation'] != undefined || this.props.const_var.BuildingPriceArrar['overhead_door_calculation'] != undefined)) {
        chkArr = true;
      }
      // console.log(this.props.const_var.tax,"this.props.const_var.tax")
      return (
        <>

          {(this.props.params.tax_exempt == false) ?
            <>
              <div className='card-top-pills'>
                <div class='form-group mb-0'>
                  <label class='control-label'>Zip Code</label>
                  <div className='row gutters-5 align-items-center'>
                    <div className='col-6'>  
                        <div className="floating-label-input">
                          <TextField
                            name="zipcode"
                            value={this.props.params.tax_zipcode}
                            maxLength="5"
                            onKeyUp={e => validate.numericCheckForZipCode(e)}
                            onChange={e => { e.target.value.length < 6 && this.props.callTaxApiAndCalculatePrice(e.target.value) }}
                          />
                        </div>
                    </div>
                    <div className='col-auto d-none'>
                      <button type="button" className="btn btn-primary-link btn-sm p-0">+ Add Address</button>
                    </div>
                  </div>
                </div>
              </div>

              <div className='drop-addbox d-none'>
                <div className='form-group-md'>
                  <label className='control-label'>Address</label>
                  <div className="floating-label-input">
                    <TextField
                      name="Address"
                      value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].finance_company : ''}
                      onChange={e => this.props.updatePaymentOption(e.target.value, 'finance_company')}
                    />
                  </div>
                </div>
                <div className='row'>
                  <div className='col-6'>
                    <div className='form-group-md'>
                      <label className='control-label'>City</label>
                      <div className="floating-label-input">
                        <TextField
                          name="City"
                          value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].application_id : ''}
                          onChange={e => this.props.updatePaymentOption(e.target.value, 'application_id')}
                        />
                      </div>
                    </div>
                  </div>
                  <div className='col-6'>
                    <div className='form-group-md'>
                      <label className='control-label'>Zip Code</label>
                      <div className="floating-label-input">
                        <TextField
                          name="Zip Code"
                          value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].plan_no : ''}
                          onChange={e => this.props.updatePaymentOption(e.target.value, 'plan_no')}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className='row'>
                  <div className='col-9'>
                    <div className='form-group-md'>
                      <label className='control-label'>County</label>
                      <div className='row gutters-5'>
                        <div className='col'>
                          <div className="floating-label-input">
                            <TextField
                              name="County"
                              value={this.props.params.paymentmode != "cash" ? this.props.const_var.paymentOptionObj[this.props.params.paymentmode].plan_no : ''}
                              onChange={e => this.props.updatePaymentOption(e.target.value, 'plan_no')}
                            />
                          </div>
                        </div>
                        <div className='col-auto'>
                        <button type='button' className="btn btn-primary btn-sm">FETCH</button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>                                
              </div>
              </>
            : null
          }

          <div className='card-bottom-pills'>
            {(this.props.params.tax_exempt == false) ?
              <div className='add-box-default'>
                <div className='add-item-box-default'>
                  <div class='form-group'>
                    <div class='control-label-bar'>
                      <label class='control-label'>Tax 1</label>
                      <div class='control-label-action'>
                        <div className="price-box-type-2">
                          <span>${(this.props.const_var.tax != undefined && this.props.const_var.tax.amount != undefined) ? this.props.const_var.tax.amount : 0}</span>
                        </div>
                      </div>
                    </div>
                    <div className="floating-label-input">
                      <Select
                        value={(this.props.const_var.tax.name != undefined && this.props.const_var.tax.name != '') ? this.props.const_var.tax.name : 'sales_tax'}
                        onChange={e => this.props.TaxDepositCalculation(e.target.value, 'tax', "name")}
                        options={this.props.const_var.taxDropDownValue.map((val, key) => {
                          return (
                            {
                              "value": val.value,
                              "label": val.label
                            }
                          )
                        })}
                      />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col-6'>
                      <div className='form-group'>
                        <label class='control-label'>Amount</label>
                        <div class={"input-group floating-label-input" + (!this.props.const_var.is_price_edit ? ' disable-edit' : '')}>
                          <TextField
                            placeholder="Tax Charges % Or $"
                            className=""
                            name="quantity"
                            maxLength={(this.props.const_var.tax != undefined && this.props.const_var.tax.type == 'per') ? "8" : "8"}
                            value={(this.props.const_var.tax != undefined) ? this.props.const_var.tax.percentage : 0}
                            onKeyUp={e => validate.numericCheckwithDecimalValForTax(e)}
                            onChange={e => this.props.TaxDepositCalculation(e.target.value, 'percentage', "quantity")}
                          />
                          <div class="input-group-append">
                            <span class="input-group-text">
                              <div className='toggle-checkgroup'>
                                <input type="checkbox" id="amount_dis" class="toggle-checkbox" checked={this.props.const_var.tax.type !== "per" ? true : false}/>
                                <label for="amount_dis" className='toggle-label-checkbox'>
                                  <div className='unit parcent' onClick={e => this.props.TaxDepositCalculation('%', 'tax', "type")}>%</div>
                                  <div className='unit dollar' onClick={e => this.props.TaxDepositCalculation('$', 'tax', "type")}>$</div>
                                </label>
                              </div>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {(this.props.const_var.MoreTaxinputs && this.props.const_var.MoreTaxinputs.length > 0) ?
                    <></> :
                    <div className='add-control'>
                      <button type="button" onClick={(e) => this.props.AddandRemoveComponent(e, "add", '', 'addMoreTax')} className={(this.props.const_var.MoreTaxinputs && this.props.const_var.MoreTaxinputs.length > 1) ? "btn btn-primary-link btn-sm p-0 p-0  d-none" : "btn btn-primary-link btn-sm p-0 p-0"} style={{textTransform:'none'}}>+ Add more</button>
                    </div>
                  }
                </div>

                {(this.props.const_var.MoreTaxinputs && this.props.const_var.MoreTaxinputs.length > 0) ?
                  <>
                    {
                      this.props.const_var.MoreTaxinputs.map((val, index) => {
                        return (
                          <>
                            <div className='add-item-box-default'>
                              <div className='form-group'>
                                <div class='control-label-bar'>
                                  <label class='control-label'>Tax {index + 2}</label>
                                  <div class='control-label-action'>
                                    <div className="price-box-type-2">
                                      {((this.props.const_var.tax != undefined)) ?
                                        <span>${(this.props.const_var.MoreTaxinputs[index] != undefined && this.props.const_var.MoreTaxinputs[index].amount != undefined) ? this.props.const_var.MoreTaxinputs[index].amount : 0}</span>
                                        : null
                                      }
                                    </div>
                                  </div>
                                </div>
                                <div className="floating-label-input">
                                  <Select
                                    value={(this.props.const_var.MoreTaxinputs[index].name != undefined && this.props.const_var.MoreTaxinputs[index].name != '') ? this.props.const_var.MoreTaxinputs[index].name : 'sales_tax'}
                                    className="cpanelselect"
                                    onChange={e => this.props.extraItemsAction(e.target.value, 'addNewTax', val, index, 'name', 'addNewTax')}
                                    options={this.props.const_var.taxDropDownValue.map((val, key) => {
                                      return (
                                        {
                                          "value": val.value,
                                          "label": val.label
                                        }
                                      )
                                    })}
                                  />
                                </div>
                              </div>
                              <div className='row'>
                                <div className='col-6'>
                                  <div className='form-group'>
                                    <label class='control-label'>Amount</label>
                                    <div class="input-group floating-label-input">
                                      <TextField
                                        placeholder="Tax Percentage"
                                        name="quantity"
                                        maxLength={(this.props.const_var.MoreTaxinputs[index] != undefined && this.props.const_var.MoreTaxinputs[index].type == 'per') ? "8" : "8"}
                                        value={(this.props.const_var.MoreTaxinputs[index] != undefined && this.props.const_var.MoreTaxinputs[index].percentage != null) ? this.props.const_var.MoreTaxinputs[index].percentage : 0}
                                        onKeyUp={e => validate.numericCheckwithDecimalValForTax(e)}
                                        onChange={e => this.props.extraItemsAction(e.target.value, 'addNewTax', val, index, 'percentage', 'addNewTax')}
                                      />
                                      <div class="input-group-append">
                                        <span class="input-group-text">
                                          <div className='toggle-checkgroup'>
                                            <input type="checkbox" id={`amount${index + 2}`} class="toggle-checkbox" checked={val.type !== "amt" ? false : true}/>
                                            <label for={`amount${index + 2}`} className='toggle-label-checkbox'>
                                              <div className='unit parcent' onClick={e => this.props.extraItemsAction('%', 'addNewTax', val, index, 'type', 'addNewTax')}>%</div>
                                              <div className='unit dollar' onClick={e => this.props.extraItemsAction('$', 'addNewTax', val, index, 'type', 'addNewTax')}>$</div>
                                            </label>
                                          </div>
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className='add-control'>
                                {(this.props.const_var.MoreTaxinputs && this.props.const_var.MoreTaxinputs.length - 1 == index && this.props.const_var.MoreTaxinputs.length <= 4) ? <button type="button" onClick={(e) => this.props.AddandRemoveComponent(e, "add", '', 'addMoreTax')} className="btn btn-primary-link btn-sm p-0" style={{textTransform:'none'}}>+ Add more</button> : ''}

                                <button type="button" onClick={(e) => this.props.AddandRemoveComponent(e, "remove", index, 'addMoreTax')} className="btn btn-default-link btn-sm p-0" style={{textTransform:'none'}}>— Remove</button>
                              </div>
                            </div>
                          </>

                        )
                      })
                    }
                  </>
                  : null
                }
              </div>
              : null
            }
            <div className={(this.props.params.tax_exempt == false) ? 'form-group mb-0' : 'form-group mb-0'}>
              <div className="check-group">
                <Checkbox
                  label="Tax Exempt"
                  checked={this.props.params.tax_exempt}
                  onChange={e => this.showTaxCal(e.target.value)}
                />
              </div>
              {(this.props.params.tax_exempt == true) ?
                <div class="exempt-text"><p>This customer is tax exempt. Documents are required</p></div>
              : null}
            </div>          
          </div>
           

        </>

      );
    }
  }
}



const mapStateToProps = (state) => {
  return { ...state.reducer, ...state.leadcustomerReducer }
}
export default connect(
  mapStateToProps,
  //mapDispachToProps,
  actionCreator
)(Tax);


